import React, { useEffect, useState } from 'react';
import { TabPanel } from '@wordpress/components';
import ColorPalette from "./ColorPalette"
import Typography from './Typography';
import MailFrom from "./MailFrom"
import MaintenanceMode from "./MaintenanceMode"
import License from "./License"

function Tabs() {

	let active_tab = localStorage.getItem('active-tab');
	
	const tabset = [
		{name:'color-palette',title:'Color Palette',className: 'davenport-color-palette',
		content: <ColorPalette />},
		{name:'typography',title:'Typography',className: 'davenport-typography',
		content: <Typography />},
		{name:'mail_from',title:'Mail From',className: 'davenport-mail_from',
		content: <MailFrom />},
		{name:'maintenance-mode',title:'Maintenance Mode',className: 'davenport-maintenance-mode',
		content: <MaintenanceMode />},
		{name:'license',title:'License',className: 'davenport-license',
		content: <License />}
	];

	const onSelect = ( tabName ) => {};

	return (
		<TabPanel 
			className="davenport-tabs"
			activeClass="active-tab"
			initialTabName={ active_tab }
			onSelect={ onSelect }
			tabs={ tabset }
		>
			{({ name, content, className }) => <div className={className} key={name}>{content}</div>}
		</TabPanel>
	);

}

export default Tabs